import { API } from "@/lib/api";

/**
 * Resolve the best source URL for a media item.
 * Priority: storage_path (object storage) → external_url → legacy data_base64.
 */
export function mediaSrc(item) {
  if (!item) return "";
  if (item.storage_path) return `${API}/media/file/${item.storage_path}`;
  if (item.external_url) return item.external_url;
  if (item.data_base64) return item.data_base64;
  return "";
}

/** Thumbnail src (for videos). Falls back to mediaSrc for photos. */
export function thumbSrc(item) {
  if (!item) return "";
  if (item.thumbnail_storage_path) return `${API}/media/file/${item.thumbnail_storage_path}`;
  if (item.thumbnail_base64) return item.thumbnail_base64;
  return mediaSrc(item);
}
